import axios, { AxiosResponse } from 'axios';
import type {
  UserProfileResponse,
  UserProfileAddressListResponse,
  UserProfileAddressSaveRequest,
  UserProfileAddressSaveResponse,
  UserProfileAddressDeleteRequest,
} from '@/venit/services/model/techpubs-cms';
import type { UserProfileUpdateRequest } from '@/venit/services/model/techpubs-cms';

export default class UserProfileService {
  public getProfile(): Promise<AxiosResponse<UserProfileResponse>> {
    return axios.get<UserProfileResponse>('/api/v1/users/profile');
  }

  public updateProfile(request: UserProfileUpdateRequest): Promise<AxiosResponse<UserProfileResponse>> {
    return axios.post<UserProfileResponse>('/api/v1/users/profile', request);
  }

  public listAddresses(): Promise<AxiosResponse<UserProfileAddressListResponse>> {
    return axios.post<UserProfileAddressListResponse>('/api/v1/users/profile/addresses/list');
  }

  public saveAddress(request: UserProfileAddressSaveRequest): Promise<AxiosResponse<UserProfileAddressSaveResponse>> {
    return axios.post<UserProfileAddressSaveResponse>('/api/v1/users/profile/addresses/save', request);
  }

  public deleteAddress(request: UserProfileAddressDeleteRequest): Promise<AxiosResponse<void>> {
    return axios.post<void>('/api/v1/users/profile/addresses/delete', request);
  }
}
